import { render, staticRenderFns } from "./forgotPasswordPage.vue?vue&type=template&id=956845c0&"
import script from "./forgotPasswordPage.vue?vue&type=script&lang=js&"
export * from "./forgotPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./forgotPasswordPage.vue?vue&type=style&index=0&id=956845c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports